export interface MarketPath {
  id: 'app' | 'business'
  name: string
  audience: string
  monetisation: string
  /** Minimal capability reminder — Slide 8 carries the product explanation. */
  note?: string
  market: {
    value: string
    unit: string
    label: string
    source: string
  }
  opportunity: {
    value: string
    label: string
    basis: string
  }
  stages: { label: string; detail?: string }[]
}

export const marketPaths: MarketPath[] = [
  {
    id: 'app',
    name: 'VEXU App',
    audience: 'Individuals & professionals',
    monetisation: 'Subscription + usage',
    market: {
      value: '9.07M',
      unit: 'U.S. self-employed workers',
      label: 'Focused U.S. launch beachhead',
      source: 'U.S. Bureau of Labor Statistics, CPS, Jul 2026',
    },
    opportunity: {
      value: '$1.63B',
      label: 'Illustrative annual revenue opportunity',
      basis: '9.07M × $179.88 annualized Starter pricing',
    },
    stages: [
      { label: 'U.S. beachhead' },
      {
        label: 'Broader professional market',
        detail: '71.3M U.S. management, professional & related workers',
      },
      { label: 'International expansion' },
    ],
  },
  {
    id: 'business',
    name: 'VEXU Business',
    audience: 'Businesses',
    monetisation: 'Platform + usage',
    note: 'Voice · WhatsApp · Workflows · Integrations',
    market: {
      value: '6.40M',
      unit: 'U.S. employer firms',
      label: 'Focused U.S. business opportunity',
      source: 'U.S. Census Bureau, Statistics of U.S. Businesses',
    },
    opportunity: {
      value: '$7.60B',
      label: 'Illustrative annual revenue opportunity',
      basis: '6,395,635 employer firms × $1,188 annualized Starter pricing',
    },
    stages: [
      { label: 'SMBs', detail: '36.2M U.S. small businesses (SBA, 2026)' },
      { label: 'Mid-market' },
      { label: 'Enterprise' },
      { label: 'International expansion' },
    ],
  },
]

/** Illustrative bottom-up opportunity, built from VEXU's own pricing. */
export const combinedOpportunity = {
  total: '$9.23B',
  label: 'Illustrative U.S. revenue opportunity',
  parts: [
    { value: '$1.63B', label: 'Consumer / Prosumer' },
    { value: '$7.60B', label: 'Business' },
  ],
}

/** Management base case, Year 3. */
export const baseCase = {
  revenue: '$11.91M',
  exact: '$11,908,493',
  share: '~0.13%',
  consumer: {
    value: '20,982 billed subscribers',
    share: '≈ 0.23% of the 9.07M focused beachhead',
  },
  business: {
    value: '1,441 active business customers',
    share: '≈ 0.023% of the 6.40M employer-firm market',
  },
}

export const sourcesNote =
  'Sources: U.S. Bureau of Labor Statistics (2025; Jul 2026); U.S. Census Bureau, Statistics of U.S. Businesses; U.S. SBA Office of Advocacy (2026). VEXU pricing and Year-3 Base Case from management financial model.'

export const illustrativeNote =
  'Illustrative bottom-up revenue opportunity, not a forecast of obtainable market. Consumer/prosumer and business audiences may overlap.'
